import React from "react";
import { createRoot } from "react-dom/client";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import App from "./App";
import "react-datepicker/dist/react-datepicker.css";
import "./style/index.css";
import keycloak from "./keycloak";

const root = createRoot(document.getElementById("root"));

// Keycloak 26.x / modern browsers:
// Setting silentCheckSsoRedirectUri still triggers the 3rd-party-cookie iframe
// (check3pCookiesSupported), which times out with:
//   "Timeout when waiting for 3rd party check iframe message."
// Disable login iframe AND omit silent SSO so check-sso uses a top-level
// prompt=none redirect instead of iframes. Main.js still calls login() when needed.
root.render(
  <ReactKeycloakProvider
    authClient={keycloak}
    initOptions={{
      onLoad: "check-sso",
      flow: "standard",
      pkceMethod: "S256",
      checkLoginIframe: false,
    }}
    onEvent={(event, error) => {
      console.log("Keycloak event:", event);
      if (event === "onAuthLogout") {
        console.log("User logged out");
      }
      if (error) console.error("Keycloak error:", error);
    }}
    onTokens={(tokens) => {
      console.log("Keycloak tokens:", tokens);
    }}
  >
    <App />
  </ReactKeycloakProvider>,
);
